if (!window.faqScriptLoaded) {
  window.faqScriptLoaded = true;

  document.addEventListener("DOMContentLoaded", () => {
    const faqItems = document.querySelectorAll(".faq-item");

    // open first FAQ by default
    if (faqItems.length > 0) {
      const firstItem = faqItems[0];
      const q = firstItem.querySelector(".faq-question");
      const a = firstItem.querySelector(".faq-answer");

      firstItem.classList.add("open");
      q.classList.add("active");
      a.style.height = a.scrollHeight + "px";
    }

    faqItems.forEach((item) => {
      const q = item.querySelector(".faq-question");
      const a = item.querySelector(".faq-answer");

      q.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        faqItems.forEach((i) => {
          i.classList.remove("open");
          i.querySelector(".faq-question").classList.remove("active");
          i.querySelector(".faq-answer").style.height = "0";
        });

        if (!isOpen) {
          item.classList.add("open");
          q.classList.add("active");
          a.style.height = a.scrollHeight + "px";
        }
      });
    });
  });
}
